<script>
import PageHeader from '@/components/ux/pageHeader/page-header.vue';
import columns from '@/pages/giftCard/images/columns';
import { mapActions, mapState } from 'vuex';
import {
  CheckOutlined, DownOutlined, EditOutlined, UpOutlined,
} from '@ant-design/icons-vue';
import CreateNewGiftCardImages from '@/components/modals/Create-new-gift-card-images.vue';

export default {
  components: {
    DownOutlined,
    UpOutlined,
    CreateNewGiftCardImages,
    EditOutlined,
    CheckOutlined,
    PageHeader,
  },
  data() {
    return {
      title: 'Gift images',
      type: 'gift_card_image',
      columns: columns(),
      showCreate: false,
      editableData: {},
      selectedField: '',
    };
  },
  methods: {
    ...mapActions({
      getCardImagesAction: 'products/getCardImages',
      changeGiftImageAction: 'products/changeGiftImage',
      deleteGiftImageAction: 'products/deleteGiftImage',
    }),
    openCreateWindow() {
      this.showCreate = true;
    },
    edit(value, fieldType) {
      this.editableData = value;
      this.selectedField = fieldType;
    },
    save(value) {
      this.changeGiftImageAction({
        id: value.id,
        name: value.name,
        index: value.index,
      });
      this.editableData = {};
      this.selectedField = '';
    },
    updateImageOrder(value) {
      value.forEach((item) => {
        this.changeGiftImageAction({
          id: item.id,
          name: item.name,
          index: item.index,
        });
      });
    },
    deleteGiftCard(id) {
      this.deleteGiftImageAction(id);
    },
  },
  mounted() {
    this.getCardImagesAction();
  },
  computed: {
    ...mapState({
      Images: (state) => state.products.cardImages,
    }),
  },
};
</script>

<template>
  <PageHeader :title="title"/>
  <div  class="create-button">
    <a-button
      type="primary"
      html-type="button"
      @click="openCreateWindow"
    >
      Create new gift card image
    </a-button>
    <div v-if="showCreate">
      <CreateNewGiftCardImages v-model:show="showCreate" />
    </div>
  </div>
  <div >
    <a-table
      :columns="columns"
      :dataSource="Images"
      :pagination="false"
    >
      <template #bodyCell="{ column, text, record, index }">
        <template v-if="column.dataIndex === 'imageUri'">
          <div>
            <a-image
              :width="200"
              :src="record.imageUri"
            />
          </div>
        </template>
        <template v-if="column.dataIndex === 'name'">
          <div >
            <div v-if="
                editableData.id
                && editableData.id === record.id
                && selectedField === 'name'
              ">
              <a-input v-model:value="editableData.name" @pressEnter="save(record)" />
              <check-outlined @click="save(record)" />
            </div>
            <div v-else >
              {{ text || ' ' }}
              <edit-outlined @click="edit(record, 'name')" />
            </div>
          </div>
        </template>
        <template v-if="column.dataIndex === 'index'">
          <div class="order-buttons">
            <a-button
              class="order-button-up"
              v-if="index !== 0"
              type="primary"
              html-type="button"
              @click="updateImageOrder([
                { id: record.id, index: Images[index - 1].index },
                { id: Images[index - 1].id, index: record.index }
              ])"
            >
              <template #icon>
                <UpOutlined />
              </template>
            </a-button>
            <a-button
              v-if="index !== Images.length - 1"
              type="primary"
              html-type="button"
              @click="updateImageOrder([
                { id: record.id, index: Images[index + 1].index },
                { id: Images[index + 1].id, index: record.index }
              ])"
            >
              <template #icon>
                <DownOutlined />
              </template>
            </a-button>
          </div>
        </template>
        <template v-else-if="column.dataIndex === 'actions'">
          <div>
            <a-popconfirm title="Sure to delete?" @confirm="deleteGiftCard(record.id)">
              <a-button type="primary" html-type="button" danger>
                Delete
              </a-button>
            </a-popconfirm>
          </div>
        </template>
      </template>
    </a-table>
  </div>
</template>

<style scoped lang="scss">
.create-button {
  display: flex;
  justify-content: flex-end;
  padding: 10px 20px;
}
.order-buttons {
  display: flex;
  flex-direction: column;
}
.order-button-up {
  margin-bottom: 10px;
}
</style>
